import React from 'react';
import '../assets/css/footer.css';

function Footer() {
  return (
  <footer className="footer-section">
    <h2>Developed by Arthur Viegas</h2>
  </footer>
  )
}

export default Footer;